import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import DynamicPriceIcon from '../icons/DynamicPriceIcon'

const useStyles = makeStyles()(theme => ({
  dynamicPricesAlertContainer: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.shape.snackbar.backgroundColor.informationLight,
    display: 'flex',
    alignItems: 'center',
  },
  dynamicPricesAlertText: {
    color: theme.palette.grey.grey01,
    fontSize: '14px',
    lineHeight: '18px',
    textAlign: 'center',
  },
}))

/**
 * Component for displaying alert about dynamic electricity prices.
 * No params required
 */
const WallboxDynamicPriceAlert = (): React.ReactElement => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  return (
    <Box className={classes.dynamicPricesAlertContainer}>
      <DynamicPriceIcon />
      <Box width={'100%'}>
        <Typography className={classes.dynamicPricesAlertText}>{t('emobility.wallbox.alert-title')}</Typography>
      </Box>
    </Box>
  )
}

export default WallboxDynamicPriceAlert
